// The icons a player can pick in the Lobby's Profil tab (components/lobby/ProfileTab.jsx): struck medals
// rendered in 3D by tools/avatars/medals/, served by the app itself from public/avatars/. The same
// list as AVATARS in backend/player_profile.py (avatars.test.js checks it): the server accepts only
// those, and sends back the picture to show, so the game's avatars need nothing more.
export const AVATARS = [
  "wolf", "goldlion", "eagle", "cobra", "scorpion", "skull",
  "nvg", "reticle", "ace", "king", "joker", "rank",
];

export const avatarUrl = (id) => `/avatars/${id}.webp`;
